


import {
  ArrowBack,
  CalendarToday,
  Info,
  Paid,
  People,
  Tag,
  Work
} from '@mui/icons-material';
import { useEffect, useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { useLocation, useNavigate } from 'react-router-dom';

const ReceiveCampaignDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { campaignDetails } = location.state || {};
console.log("all  details of cmaapifn   ", campaignDetails)
  const [loading, setLoading] = useState(true);
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 790);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  if (!campaignDetails) {
    return <div>No campaign details available</div>;
  }

  const handleApplyClick = () => {
    if (campaignDetails?._id) {
      navigate('/apply', { state: { campaignId: campaignDetails._id } });
    }
  };
    const handleApplicantsClick = () => {
    navigate('/getappicants', { state: { campaignDetails } });
  };

  // const handleImageClick = (brandId) => {
  //   navigate('/brandinfo', { state: { brandId } });
  // };

  const handleBackClick = () => {
    navigate(-1);
  };

  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white py-4 px-4 shadow-md flex items-center">
        <button onClick={handleBackClick} className="text-black">
          <ArrowBack fontSize="medium" />
        </button>
        <h1 className="text-xl font-semibold text-black ml-4">Campaign Details</h1>
      </div>

      {/* Background Image Section */}
      <div
       
        className="relative w-full h-80 sm:h-96 md:h-[400px] bg-gray-200 cursor-pointer"
      >
        {loading ? (
          <Skeleton height="100%" width="100%" />
        ) : (
          <div
  className="absolute inset-0 bg-center"
          style={{
                 height: isSmallScreen ? '390px' : '430px', // taller on larger devices
    backgroundImage: `url(${campaignDetails.campaignImages[0]})`,
    backgroundSize: '100% 100%', // behaves like object-fill
    backgroundRepeat: 'no-repeat'
  }}
          />
        )}
        <div className="absolute inset-0 bg-black bg-opacity-30"></div>

        {/* Centered Profile Picture */}
        <div className="absolute bottom-[-3.5rem] left-1/2 transform -translate-x-1/2 z-10">
          {loading ? (
            <Skeleton circle={true} height={100} width={100} />
          ) : (
            <img
              className="w-28 h-28 rounded-full border-4 border-white shadow-lg object-cover"
              src={campaignDetails.profilePic}
              alt={`${campaignDetails.brandName} Profile`}
            />
          )}
        </div>
      </div>

      {/* Brand Info Row sssss*/}
      <div
        className="flex justify-between items-center px-6 mt-16"
     
      >
        {loading ? (
          <Skeleton width={200} height={60} />
        ) : (
          <div className="flex items-center space-x-4 mt-10">
            <img
              className="w-14 h-14 rounded-full object-cover shadow-md"
              src={campaignDetails.profilePic}
              alt={`${campaignDetails.brandName} Profile`}
            />
            <h2 className="text-2xl font-semibold text-gray-800">{campaignDetails.brandName}</h2>
          </div>
        )}

        {!loading && (
          <div className="bg-gray-200 text-black px-4 py-2 rounded-full text-base font-medium shadow-md flex items-center cursor-pointer"  onClick={handleApplicantsClick}>
            <People fontSize="small" className="mr-1" />
            {campaignDetails.totalApplicants} Applicants
          </div>
        )}
      </div>

      {/* Campaign Info Section */}
      <div className="mt-6 px-6 py-8 bg-white rounded-t-3xl shadow-inner">
        <div className="text-center mb-6">
          {loading ? (
            <Skeleton width={200} height={40} />
          ) : (
            <h1 className="text-3xl font-bold">{campaignDetails.campaignName}</h1>
          )}
        </div>

        {loading ? (
          <>
            <Skeleton height={20} width="100%" count={4} />
          </>
        ) : (
          <div className="space-y-5 text-lg text-gray-700">
            <p><Info className="text-blue-600 mr-2" /><strong>Type:</strong> {campaignDetails.campaignType}</p>
            <p><Paid className="text-green-600 mr-2" /><strong>Budget:</strong> ₹{campaignDetails.budget}</p>
            <p><People className="text-purple-600 mr-2" /><strong>Follower Range:</strong> {campaignDetails.followerRange[0]} - {campaignDetails.followerRange[1]}</p>
            <p><Work className="text-orange-600 mr-2" /><strong>Task:</strong> {campaignDetails.task}</p>
            <p><Tag className="text-pink-600 mr-2" /><strong>Tags:</strong> {campaignDetails.tags.join(', ')}</p>
            <p><CalendarToday className="text-gray-600 mr-2" /><strong>Start:</strong> {new Date(campaignDetails.startDate).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: '2-digit' })}</p>
            <p><CalendarToday className="text-gray-600 mr-2" /><strong>End:</strong> {new Date(campaignDetails.endDate).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: '2-digit' })}</p>
            <p className="text-gray-600"><Info className="text-gray-500 mr-2" /><strong>Description:</strong> {campaignDetails.description}</p>
          </div>
        )}

  {/* Image Gallerysss detail  renenew*/}
        {!loading && campaignDetails?.campaignImages?.length > 0 && (
          <div className="mt-8">
            <h3 className="text-xl font-semibold text-gray-800 mb-3">Images  related to this campaign</h3>
            <div className="flex flex-wrap gap-3">
              {campaignDetails.campaignImages.map((imgUrl, index) => (
                <a
  key={index}
  href={imgUrl}
  target="_blank"
  rel="noopener noreferrer"
>
  {/* <img
    src={imgUrl}
    alt={`Campaign Img ${index + 1}`}
    className="w-44 h-28 object-fit-cover rounded-lg shadow-sm border mt-3"
  /> */}
  <img
  src={imgUrl}
  alt={`Campaign Img ${index + 1}`}
  className="w-28 h-20  sm:w-36 sm:h-24 md:w-44 md:h-28 object-fit-cover rounded-lg shadow-sm border mt-3"
/>

</a>

              ))}
            </div>
          </div>
        )}
        {/* {!loading && (
          <div className="text-center mt-10">
            <button
              className="bg-gradient-to-br from-purple-600 to-blue-500 text-white font-semibold rounded-full text-lg px-6 py-3 hover:shadow-xl transition-transform duration-200 hover:scale-105"
              onClick={handleApplyClick}
            >
              Apply for Campaign
            </button>
          </div>
        )} */}

     



      </div>
    </div>
  );
};

export default ReceiveCampaignDetails;
